const LocalStorageKeys = {
  current_application: 'cap',
  definitions: 'definitions',
  project: 'project',
  todayMeasurements: 'todayAllMeasurementList',
  todayLastEvaluatedKey: 'todayLastEvaluatedKey',
  todayCurrentMeasurement: 'todayCurrentMeasurementKey',
  searchMeasurements: 'searchAllMeasurementList',
  searchLastEvaluatedKey: 'searchLastEvaluatedKey',
  searchCurrentMeasurement: 'searchCurrentMeasurementKey',
  refreshDate: 'measurementRefreshDate',
  readMaxKey: 'alreadyReadMaxKey'
}

const removeAllItems = function () {
  window.localStorage.clear()
}

const getItem = function (key) {
  let json = window.localStorage.getItem(key)
  if (json) {
    json = JSON.parse(json)
    if (isValid(json.expired)) {
      return json.data
    }
  }
  return null
}

const setItem = function (key, json, expired) {
  var date = new Date()
  date.setMinutes(date.getMinutes() + 2)
  let val = {
    data: json,
    expired: expired || date
  }

  window.localStorage.setItem(key, JSON.stringify(val))
}

const removeItem = function(key) {
  window.localStorage.removeItem(key)
}

const isDefinitionReady = function(){
  let d = getItem(LocalStorageKeys.definitions)
  if (d) return true
  else return false
}

const isValid = (date) =>{
  const now = new Date()

  if (!date || new Date(date) < now) {
    console.log('expired')
    return false
  }
  return true
}

const getItemToday = function (key) {
  let json = window.localStorage.getItem(key)
  if (json) {
    json = JSON.parse(json)
    if (isValidToday(json.expired)) {
      return json.data
    }
  }
  return null
}

const setItemToday = function (key, json) {
  var date = new Date()
  let year = date.getFullYear()
  let month = date.getMonth()
  let day = date.getDate() + 1
  let val = {
    data: json,
    expired: new Date(year, month, day, 8, 59)
  }

  window.localStorage.setItem(key, JSON.stringify(val))
}

const isValidToday = (expired) =>{
  const now = new Date()

  if (!expired || new Date(expired) < now) {
    console.log('expired')
    return false
  }
  return true
}


export default {
  LocalStorageKeys,
  removeAllItems,
  getItem,
  setItem,
  removeItem,
  isDefinitionReady,
  getItemToday,
  setItemToday,
  isValidToday,
}
